export default __webpack_public_path__ + "static/media/LittleNightmares.7defe398.jpg";